import type { AdminActionStatus } from '../../../../services/adminAgent.service';

export const ACTION_STATUS_STYLES: Record<AdminActionStatus, string> = {
  pending: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200',
  approved: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  executed: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
  rejected: 'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
  expired: 'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
  failed: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
};
